import styled from "styled-components";

export const StyledContainer = styled.div`
	/* width: 1200px; */
	width: 1200px;
	padding: 0 15px;
	min-height: 100%;
	margin: 0 auto;

	@media (max-width: 420px) {
		width: 100%;
	}
`;
